import { VisibilityState } from '@tanstack/vue-table'

import { ClinicType, MoneyType, PatientType } from '@/types'

export type DiscountType = {
  type?: string
  value?: string
  formatted?: string
}

export type InvoiceDiscountType = {
  amount?: MoneyType
  formatted: string
  value: string
  type: string
}

export type InvoiceItemType = {
  id: string
  name: string
  paid_at?: string
  unit: MoneyType
  quantity: number
  subtotal: MoneyType
  discount?: InvoiceDiscountType
  total: MoneyType
  paid?: MoneyType
}

export enum InvoiceStatusEnum {
  DRAFT = 'draft',
  PENDING = 'pending',
  OVERDUE = 'overdue',
  PAID = 'paid',
  PARTIALLY_PAID = 'partially_paid',
  CANCELLED = 'cancelled',
  REFUNDED = 'refunded',
}

export type InvoiceType = {
  id: string
  number: string
  status: InvoiceStatusEnum
  subtotal: MoneyType
  discount?: InvoiceDiscountType
  total: MoneyType
  paid: MoneyType
  left_to_pay: MoneyType
  recipient?: PatientType
  items: InvoiceItemType[]
  clinic: ClinicType
  issued_at?: string
  due_at?: string
  paid_at?: string
  created_at: string
  updated_at: string
  deleted_at: string
}

export type InvoiceItemFormType = {
  id?: string
  name: string
  quantity: number
  unit: MoneyType
  discount?: InvoiceDiscountType
  source_entity_type?: string
}

export type InvoiceFormType = {
  status?: InvoiceStatusEnum
  items?: InvoiceItemFormType[]
  discount?: DiscountType
  recipientId?: string
  recipientType?: string
  patientJourneyIds?: string[]
  leadJourneyIds?: string[]
  due_at?: string
}

export type InvoiceFilterType = {
  archived?: string
  status: InvoiceStatusEnum[]
  created_at?: { start: string; end: string }
  columnVisibility?: VisibilityState
  columnOrder: string[]
}
